import moment from 'moment';
import AddressField from './AddressField'
import PriceField from './PriceField';

import { LocationIconWrapper } from './IconWrapper';
import { CustomDivider } from './CustomDivider';
import { LocationData } from './LocationTypes';
import { ReactComponent as ClockIcon } from './assets/icons/clock-small.svg';
import { ReactComponent as HomeIcon } from './assets/icons/location-home.svg';
import './LocationInfoContent.css'

interface Props {
  location: LocationData | undefined;
}

const LocationInfoContent = (props: Props) => {
  const { location } = props;
  if (!location) {
    return null;
  }

  const locationPricing = location.locationPricing;
  console.log(location)

  let maintenanceDue = null;
  let maintenanceStart = null;
  let openFrom = null;
  let openTo = null;

  if (location?.maintenanceEndingTime) {
    maintenanceDue = moment(location.maintenanceEndingTime).format(
      'D/MM/YYYY HH:mm',
    );
  }

  if (location?.maintenanceStartTime) {
    maintenanceStart = moment(location.maintenanceStartTime).format(
      'D/MM/YYYY HH:mm',
    );
  }

  if (location && !location.isAllDay) {
    openFrom = moment(location.openFrom).format('HH:mm');
    openTo = moment(location.openTo).format('HH:mm');
    console.log(openFrom, openTo)
  }

  return (
    <>
      <div className={'contentWrapper'}>
        <div className={'content'}>

          <div className={'flexRow'}>
            <LocationIconWrapper>
              <HomeIcon />
            </LocationIconWrapper>
            <p className={'text'}>
              {location.name}
            </p>
          </div>

          <AddressField location={location} />
          {location?.street && <CustomDivider style={{
            height: 2, display: 'block', background: '#ddd'
          }} />}

          {!(location?.isAllDay) &&
            <>
              <div className={'flexRow'}>
                <LocationIconWrapper>
                  <ClockIcon />
                </LocationIconWrapper>
                <p className={'text'}>
                  {'from'} {openFrom} {'to'} {openTo}
                </p>
              </div>
              <CustomDivider style={{}} />
            </>
          }
          {
            location.maintenanceStartTime && (new Date(location.maintenanceStartTime)) > (new Date()) && <div className={'flexRow'}>
              <p className={'errorText'}>
              På grunn av vedlikehold, utilgjengelig fra kl {maintenanceStart} Til {maintenanceDue}
              </p>
            </div>
          }
          {location?.isInMaintenance &&
            <>
              <div className={'flexRow'}>
                <LocationIconWrapper>
                  <ClockIcon />
                </LocationIconWrapper>
                {location?.maintenanceEndingTime ? (
                  <p className={'errorText'}>
                    På grunn av vedlikehold, utilgjengelig til kl {maintenanceDue}
                  </p>
                ) : (
                  <p className={'errorText'}>
                    Ikke tilgjengelig for vedlikehold
                  </p>
                )
                }
              </div>
              <CustomDivider style={{}} />
            </>
          }
          
          {location.subscriptionId && location?.subscriptionId !== 0 ?
            <PriceField
              locationPaymentType={0}
              mainPriceAmount={locationPricing.mainPriceAmount}
              mainPriceDuration={0} startPriceAmount={0} startPriceDuration={0}
            />
            :
            <PriceField
              locationPaymentType={locationPricing.locationPaymentType}
              mainPriceAmount={locationPricing.mainPriceAmount}
              mainPriceDuration={locationPricing.mainPriceDuration}
              startPriceAmount={locationPricing.startPriceAmount}
              startPriceDuration={locationPricing.startPriceDuration}
            />}
        </div>



      </div>
    </>
  );
};

export default LocationInfoContent;
